<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <span slot="header">最近更新</span>
      <el-form :model="form"
               ref="editForm"
               label-width="96px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onEditLevel()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="推荐1"
                          prop="recommendedV1">
              <el-select v-model="recommendedV1"
                         placeholder="请选择"
                         clearable>
                <el-option v-for="item in table"
                           :key="item.id"
                           :label="item.title"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="推荐2"
                          prop="recommendedV2">
              <el-select v-model="recommendedV2"
                         placeholder="请选择"
                         clearable>
                <el-option v-for="item in table"
                           :key="item.id"
                           :label="item.title"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">修改
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <el-row v-permission="33">
      <router-link :to="{ path: '/platform/education_form?type=1'}">
        <el-button type="primary">添加图文教程</el-button>
      </router-link>
      <router-link :to="{ path: '/platform/education_form?type=2'}">
        <el-button type="primary">添加视频教程</el-button>
      </router-link>
      <br/><br/>
    </el-row>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="教程id"></el-table-column>
        <el-table-column prop="image_url"
                         label="教程封面">
          <template slot-scope="scope">
            <img v-if="scope.row.image_url"
                 :src="scope.row.image_url+'?x-oss-process=image/resize,w_50/auto-orient,1'"
                 alt="爱零工">
          </template>
        </el-table-column>
        <el-table-column prop="title"
                         label="教程标题"></el-table-column>
        <el-table-column prop="type"
                         label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">图文</span>
            <span v-if="scope.row.type === 2">视频</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"></el-table-column>
        <el-table-column prop="level"
                         label="优先级">
          <template slot-scope="scope">
            <el-col :span="12">
              <el-input v-model="scope.row.level"
                        type="number"
                        size="mini"
                        max="255"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button type="primary"
                         size="mini">
                <i class="el-icon-edit-outline"
                   @click="editEducation(scope.row)"></i>
              </el-button>
            </el-col>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <router-link :to="{ path: '/platform/education_form?id='+scope.row.id+'&type='+scope.row.type}">
              <el-button type="text"
                         size="mini">编辑
              </el-button>
            </router-link>
            <el-button type="text"
                       size="mini"
                       v-if="scope.row.is_top === 0"
                       @click="deleteEducation(scope.row.id)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      form: {
        content: null,
        description: null,
        id: null,
        image_url: null,
        level: null,
        title: null,
        type: null,
        video_url: null,
      },
      recommendedV1: '',
      recommendedV2: '',
    }
  },
  computed: Vuex.mapState({}),
  created () {
  },
  methods: {
    ...Vuex.mapActions(['getEducationTable', 'editEducationLevel',
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getEducationTable', params)
    },
    setTableData ({data}) {
      let table = []
      data.data.forEach((row, index) => {
        table.push(row)
        if (row.is_top === 1) {
          this.recommendedV1 = row.id
        }
        if (row.is_top === 2) {
          this.recommendedV2 = row.id
        }
      })
      this.table = table
      this.setPagination(data)
    },
    onEditLevel () {
      if (this.recommendedV1 === this.recommendedV2) {
        this.$message({
          showClose: true,
          message: '填写的教程ID不能重复',
          type: 'error',
        })
        return false
      }

      return request.common('editEducationLevel', [this.recommendedV1, this.recommendedV2]).then((res) => {
        this.$message({
          showClose: true,
          message: '修改成功',
          type: 'success',
        })
        this.onRefresh()
      })
    },
    deleteEducation (id) {
      this.$confirm('确认删除该教程吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确认',
        type: 'warning',
      }).then(() => {
        return request.common('deleteEducation', id).then((res) => {
          this.$message({
            shoenvwClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.onRefresh()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    editEducation (row) {
      if (row.level <= 0) {
        this.$message({
          showClose: true,
          message: '请勿输入小于等于0的数字',
          type: 'error',
        })
        return false
      }
      filter.setLoop(this.form, row)
      return request.common('editEducation', this.form).then((res) => {
        this.$message({
          shoenvwClose: true,
          message: '修改成功',
          type: 'success',
        })
        this.onRefresh()
      })
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/platform/pages/PlatformEducationTable.vue